import type { MacroResolution, MacroResolutionLog } from '@chatsdet/workflow-cache';
import type { DryRunData } from './workflow-cache-optimize-dry-workspace.js';

export interface OptimizeDryProvenance {
  variableValues: Record<string, string>;
  macroResolutionLog: MacroResolutionLog;
}

export function collectLocalRunProvenance(runData: DryRunData): OptimizeDryProvenance {
  const variableValues: Record<string, string> = {};
  const macroResolutionLog: MacroResolutionLog = new Map();
  const inputValues = runData.metadataJson?.workflowInputValues;
  if (isObject(inputValues)) {
    for (const [key, value] of Object.entries(inputValues)) {
      if (typeof value === 'string') variableValues[key] = value;
    }
  } else if (runData.metadataJson) {
    for (const [key, value] of Object.entries(runData.metadataJson)) {
      if (typeof value === 'string') variableValues[key] = value;
    }
  }

  for (const step of runData.steps) {
    const meta = isObject(step.metadataJson) ? step.metadataJson : {};
    const variablesSet = Array.isArray(meta.variablesSet) ? meta.variablesSet : [];
    for (const raw of variablesSet) {
      if (!isObject(raw)) continue;
      if (typeof raw.key !== 'string' || typeof raw.value !== 'string') continue;
      if (raw.source === 'credential' || raw.value === '[REDACTED]') continue;
      variableValues[raw.key] = raw.value;
      if (typeof raw.macroExpression === 'string' && raw.macroExpression.length > 0) {
        macroResolutionLog.set(raw.key, {
          expression: raw.macroExpression,
          resolved: raw.value,
        } satisfies MacroResolution);
      }
    }
    const macroResolutions = Array.isArray(meta.macroResolutions) ? meta.macroResolutions : [];
    for (const raw of macroResolutions) {
      if (!isObject(raw)) continue;
      if (
        typeof raw.field === 'string' &&
        typeof raw.expression === 'string' &&
        typeof raw.resolved === 'string'
      ) {
        macroResolutionLog.set(raw.field, {
          expression: raw.expression,
          resolved: raw.resolved,
        } satisfies MacroResolution);
      }
    }
  }

  return { variableValues, macroResolutionLog };
}

function isObject(value: unknown): value is Record<string, unknown> {
  return typeof value === 'object' && value !== null && !Array.isArray(value);
}
